<div class="ion-padding bg-white">
  <input id="file" class="hide" #file name="file"
    accept="image/*,.doc, .docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/pdf"
    type="file" name="file" (change)="selectFile($event.target)" />
  <!-- Pendiente de validacion -->
  <!-- Revisión correcta -->
  <div>
    <form [formGroup]="dataForm" (ngSubmit)="submit()">
      <!-- CÉDULA PRINCIPAL -->
      <ion-item>
        <ion-input label="Cédula Profesional *" labelPlacement="floating" formControlName="cedula"></ion-input>
      </ion-item>
      <ion-text color="danger" *ngIf="dataForm.get('cedula').touched && dataForm.get('cedula').hasError('required')">
        La cédula es obligatoria.
      </ion-text>
      <!-- ESPECIALIDAD 1 -->
      <!-- <ion-item>
    <ion-select label="Especialidad 1" labelPlacement="floating" formControlName="specialty1">
      <ion-select-option *ngFor="let s of specialties" [value]="s.id">
        {{ s.name }}
      </ion-select-option>
    </ion-select>
  </ion-item>
  <ion-item>
    <ion-input label="Cédula Especialidad 1" labelPlacement="floating" formControlName="professionalID1"></ion-input>
  </ion-item>
  <ion-text color="danger"
    *ngIf="dataForm.get('specialty1').touched && dataForm.get('specialty1').hasError('required')">
    La especialidad 1 es obligatoria.
  </ion-text>
  <ion-text color="danger"
    *ngIf="dataForm.get('professionalID1').touched && dataForm.get('professionalID1').hasError('required')">
    La cédula de especialidad 1 es obligatoria.
  </ion-text> -->
      <!-- ESPECIALIDAD 2 -->
      <!-- <ion-item>
    <ion-select label="Especialidad 2" labelPlacement="floating" formControlName="specialty2">
      <ion-select-option *ngFor="let s of specialties" [value]="s.id">
        {{ s.name }}
      </ion-select-option>
    </ion-select>
  </ion-item>
  <ion-item>
    <ion-input label="Cédula Especialidad 2" labelPlacement="floating" formControlName="professionalID2"></ion-input>
  </ion-item>
  <ion-text color="danger" *ngIf="dataForm.get('specialty2').hasError('required')">
    La especialidad 2 es obligatoria.
  </ion-text>
  <ion-text color="danger" *ngIf="dataForm.get('professionalID2').hasError('required')">
    La cédula de especialidad 2 es obligatoria.
  </ion-text> -->
      <!-- NUEVOS ERRORES -->
      <!-- <ion-text color="danger" *ngIf="dataForm.get('specialty2').hasError('sameSpecialty')">
    Las especialidades deben ser distintas.
  </ion-text>
  <ion-text color="danger" *ngIf="dataForm.get('professionalID2').hasError('sameCedula')">
    Las cédulas de especialidad deben ser distintas.
  </ion-text> -->
      <ion-button expand="full" type="submit" [disabled]="dataForm.invalid || isLoading" color="tertiary">
        {{ button }}
      </ion-button>
    </form>
  </div>
</div>